export const Logo = ({ dark = false }) => (
  <a href="#top" className="flex items-center gap-3 group" data-testid="brand-logo" aria-label="Shashank Chaudhary and Co — home">
    <img src="/logo.jpeg" alt="Shashank Chaudhary & Co — CA India official logo"
      className="h-11 w-11 shrink-0 rounded-xl bg-white object-cover ring-1 ring-slate-200 transition-transform duration-500 group-hover:rotate-3" />
    <span className="leading-tight">
      <span className={`block font-serif text-lg font-semibold tracking-tight ${dark ? "text-paper" : "text-ink"}`}>
        Shashank Chaudhary &amp; Co
      </span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-brass-dark">
        Chartered Accountants
      </span>
    </span>
  </a>
);
